import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { useIntl } from 'react-intl';
import { AuthoredEvidence, Evidence } from '@eas/common-web';
import { SystemUser } from '@models';
import { Fields } from './users-fields';
import { useColumns } from './users-columns';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';

export function Users() {
  const intl = useIntl();

  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [],
      REMOVE: [],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [],
      SAVE: [],
      CLOSE: [],
    },
  });

  const evidence = AuthoredEvidence.useAuthoredEvidence<SystemUser>({
    version: 2,
    identifier: 'USERS',
    apiProps: {
      url: EvidenceApiUrl.USERS,
    },
    tableProps: {
      tableName: intl.formatMessage({
        id: 'TAPIS__USERS__TABLE__TITLE',
        defaultMessage: 'Přehled uživatelů',
      }),
      columns: useColumns(),
      reportTag: ExportTag.USER_GRID,
    },
    detailProps: {
      FieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__USERS__DETAIL__TITLE',
          defaultMessage: 'Přehled uživatelů',
        }),
        showBtn: permissions,
      },
    },
  });

  return <Evidence {...evidence} />;
}
